import React, { useState } from "react";
import DomainUseCaseCard, { DOMAIN_PAGE_STYLES } from "./domainUseCaseLayout";
import PublicSectorProcessFlow from "./PublicSectorProcessFlow";
import UseCaseIndexGrid from "./UseCaseIndexGrid";
import DomainSeoHelmet from "./DomainSeoHelmet";
import DomainHiddenSeoContent from "./DomainHiddenSeoContent";

import {
  PUBLIC_SECTOR_DOMAIN_INTRO,
  PUBLIC_SECTOR_GROUPS,
  PUBLIC_SECTOR_USE_CASES_SEO,
  PUBLIC_SECTOR_DOMAIN_FAQS,
  PUBLIC_SECTOR_ITEM_LIST_JSONLD,
  PUBLIC_SECTOR_BREADCRUMB_JSONLD,
  PUBLIC_SECTOR_WEBPAGE_JSONLD,
  PUBLIC_SECTOR_FAQ_JSONLD,
} from "../../data/public-sectorUseCases";


function UseCaseCard({ useCase }) {
  return (
    <DomainUseCaseCard
      useCase={useCase}
      flow={<PublicSectorProcessFlow useCaseId={useCase.id} />}
    />
  );
}

function GroupSection({ group }) {
  const cases = PUBLIC_SECTOR_USE_CASES_SEO.filter((uc) => uc.groupId === group.id);
  if (!cases.length) return null;
  return (
    <section id={group.id} className="fin-section" aria-labelledby={`${group.id}-heading`}>
      <h2 id={`${group.id}-heading`}>{group.label}</h2>
      <div className="fin-list">{cases.map((uc) => <UseCaseCard key={uc.id} useCase={uc} />)}</div>
    </section>
  );
}

export default function PublicSectorDomainContent() {
  const [activeFilter, setActiveFilter] = useState("all");
  const visibleGroups = activeFilter === "all" ? PUBLIC_SECTOR_GROUPS : PUBLIC_SECTOR_GROUPS.filter((g) => g.id === activeFilter);
  return (
    <div className="fin-page">
      <DomainSeoHelmet
        intro={PUBLIC_SECTOR_DOMAIN_INTRO}
        domainSlug="public-sector-domain"
        useCaseCount={PUBLIC_SECTOR_USE_CASES_SEO.length}
        groupCount={PUBLIC_SECTOR_GROUPS.length}
        itemListJsonLd={PUBLIC_SECTOR_ITEM_LIST_JSONLD}
        breadcrumbJsonLd={PUBLIC_SECTOR_BREADCRUMB_JSONLD}
        faqJsonLd={PUBLIC_SECTOR_FAQ_JSONLD}
        webPageJsonLd={PUBLIC_SECTOR_WEBPAGE_JSONLD}
      />
      <style>{DOMAIN_PAGE_STYLES}</style>
      <header className="fin-hero">
        <div className="fin-hero-inner">
          <h1>{PUBLIC_SECTOR_DOMAIN_INTRO.title}</h1>
          {PUBLIC_SECTOR_DOMAIN_INTRO.content ? <p>{PUBLIC_SECTOR_DOMAIN_INTRO.content}</p> : null}
        </div>
      </header>
      <UseCaseIndexGrid useCases={PUBLIC_SECTOR_USE_CASES_SEO} groups={PUBLIC_SECTOR_GROUPS} heading="Public Sector & Government Use Cases" onFilterChange={setActiveFilter} />
      <div className="fin-wrap">{visibleGroups.map((group) => <GroupSection key={group.id} group={group} />)}</div>

      <DomainHiddenSeoContent
        domainTitle={PUBLIC_SECTOR_DOMAIN_INTRO.title}
        domainFaqs={PUBLIC_SECTOR_DOMAIN_FAQS}
        useCases={PUBLIC_SECTOR_USE_CASES_SEO}
      />
    </div>
  );
}

